export enum OrganizationUserRoles {
  OWNER = 'OWNER',
  BILLING = 'BILLING',
  MEMBER = 'MEMBER',
}
